import BasePopupHandler from './BasePopupHandler';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import {
    ITextData,
    IImageData,
} from '../../../Prototype/UI/UIItem';
import { IUIButtonData } from '../../../Prototype/UI/BaseElements/UIButton';
import GameObject from '../../../GameObject/GameObject';
import Element from '../../../Prototype/UI/Element';
import UITextComponent from '../../../Component/UI/Text';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { IRewardData } from '../../../Utility/RewardHelper';
import { IMessagePayload } from '../../../State/Game/IEntryPointData';
import { TextAlignment } from '../../../Prototype/UI/TextAlignment';
import { PopupID } from '../../../State/UI/PopupID';

export default class GiftMenuHandler extends BasePopupHandler {
    public static REWARD_AMOUNT_NAME: string = 'reward_amount_text';
    public static REWARD_TEXT_ICON_NAME: string = 'reward_amount_icon';
    public static REWARD_ICON_NAME: string = 'reward_icon';
    public static FRIEND_MESSAGE_NAME: string = 'friend_message_text';

    private reward: IRewardData;
    private payload: IMessagePayload;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.GIFT_MENU, uiSystem);
    }

    onShow(params?: { reward: IRewardData; payload: IMessagePayload }) {
        super.onShow(params);

        this.reward = params.reward;
        this.payload = params.payload;

        if (this.reward) {
            const rewardAmount: GameObject = GameObject.findByName(
                GiftMenuHandler.REWARD_AMOUNT_NAME
            )[0];
            rewardAmount.getComponent(
                UITextComponent
            ).text = this.reward.value.toString();
        }

        const friendMessage: GameObject = GameObject.findByName(
            GiftMenuHandler.FRIEND_MESSAGE_NAME
        )[0];
        const friendMessageText: string = Game.locale
            .getText('GotCoinsFrom')
            .replace('[x]', params.payload.userName);

        friendMessage.getComponent(UITextComponent).text = friendMessageText;
    }

    createPopup(params?: any) {
        const scene: string = Game.store.getState().activeScene.result;
        this.underlayParams.cacheKey = 'level_complete_underlay';
        this.submitBtnParams.button.cacheKey = 'button_medium_green';
        this.submitBtnParams.text.textLocalizationKey = 'Great';
        this.submitBtnParams.text.style = Game.style.getStyle(
            'popup.green_btn'
        );
        this.submitBtnParams.onClick = this.onSubmit.bind(this);

        super.createPopup({
            buttons: [this.submitBtnParams],
            underlay: this.underlayParams,
            title: 'ReceivedCoins',
        });

        const rewardIcon: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: `reward_icon`,
            layout: {
                anchors: [0.5, 0.44, 0.5, 0.44],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'coins_gift',
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: `friend_message_text`,
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 140, 0, 140],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'GotCoinsFrom',
                                style: {
                                    ...Game.style.getStyle(
                                        'popup.friends_hub.friend_name'
                                    ),
                                },
                                align: 'center',
                                bounds: [500, 80],
                            },
                        },
                    ],
                },
            ],
        });
        this.background.addChild(rewardIcon);

        const rewardAmountDisplay: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: `reward_amount_group`,
            layout: {
                anchors: [0.5, 0.75, 0.5, 0.75],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'UI_CoinsGift_slot',
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: `reward_amount_icon`,
                    layout: {
                        anchors: [0, 0.5, 0, 0.5],
                        pivot: [0.25, 0.5],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'UI_CoinsGift_coin',
                            },
                        },
                    ],
                    children: [],
                },
                {
                    type: 'group',
                    name: `reward_amount_text`,
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [-10, 0, -10, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                text: '999',
                                style: Game.style.getStyle(
                                    'popup.Reward_Amount'
                                ),
                                align: 'center',
                            },
                        },
                    ],
                },
            ],
        });
        this.background.addChild(rewardAmountDisplay);
    }

    protected onSubmit(): void {
        PlayerActions.receiveFriendGiftReward({
            messageData: this.payload,
            reward: this.reward,
        });
        this.closePopup();
    }

    protected audioControlItemParams: {
        title: ITextData;
        text: ITextData;
        textBg: IImageData;
        button: IUIButtonData;
    } = {
        title: {
            name: '',
            textLocalizationKey: '',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0.5, 1],
                offsets: [17, 10, 17, 10],
                scale: [1, 1],
            },
            style: {
                font: 'FrancoisOne',
                fill: '#bb3c2f',
                fontSize: '35px',
            },
        },
        text: {
            name: 'audio_status_text',
            textLocalizationKey: 'On',
            layout: {
                anchors: [0.5, 0.45, 0.5, 0.45],
                pivot: [0.5, 0.5],
                offsets: [5, 0, 5, 0],
                scale: [1, 1],
            },
            style: {
                font: 'FrancoisOne',
                fill: '#8b3130',
                fontSize: '26px',
            },
            align: TextAlignment.CENTER,
        },
        textBg: {
            name: 'audio_icon_bg',
            cacheKey: 'text_bg_short',
            layout: {
                anchors: [0, 0, 0, 0],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
        },
        button: {
            name: 'audio_control_container',
            background: {
                name: 'audio_control_bg',
                cacheKey: 'blank',
                layout: {
                    anchors: [0.05, 0.5, 0.05, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    scale: [1, 1],
                },
            },
            button: {
                name: 'audio_control_btn',
                cacheKey: '',
                layout: {
                    anchors: [0.5, 0.5, 0.5, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    scale: [1, 1],
                },
            },
        },
    };
    protected userIdParams: {
        title: ITextData;
        text: ITextData;
        bg: IImageData;
    } = {
        title: {
            name: 'user_id_title',
            textLocalizationKey: 'UserId',
            layout: {
                anchors: [0, 0.5, 0, 0.5],
                pivot: [1, 0.5],
                offsets: [7, 0, 7, 0],
            },
            style: {
                font: 'FrancoisOne',
                fill: '#bb3c2f',
                fontSize: '30px',
            },
        },
        text: {
            name: 'user_id_number',
            text: Game.sdk.getUserId(),
            style: {
                font: 'FrancoisOne',
                fill: '#8b3130',
                fontSize: '21px',
            },
            layout: {
                offsets: [0, 0, 0, 0],
            },
        },
        bg: {
            name: 'user_id_bg',
            cacheKey: 'text_bg_med',
            layout: {
                anchors: [0.5, 0.73, 0.5, 0.73],
                pivot: [0.42, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
        },
    };
}
